<template>
	<svg :class="svgClass" aria-hidden="true" v-on="$listeners">
		<use :xlink:href="iconName"/>
	</svg>
</template>

<script>
    export default {
        name: 'SvgIcon',
        props: {
            iconClass: {
                type: String,
                required: true
            },
            className: {
                type: String,
                default: ''
            }
        },
        computed: {
            iconName() {
                return `#icon-${this.iconClass}`
            },
            svgClass() {
                if (this.className) {
                    return 'svg-icon ' + this.className
                } else {
                    return 'svg-icon'
                }
            }
        }
    }
</script>

<style scoped>
	.svg-icon {
		/*width: 300px;*/
		/*height: 300px;*/
		vertical-align: -0.15em;
		fill: currentColor;
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue